module.exports = __webpack_public_path__ + "img/fund_raise_feature_icon.d876b668.svg";